import { type RootState } from "../../../../Application/globaltypes/redux";

export const messagesStateSelector = (state: RootState) => state.library.messages;

export const messagesAppliedFilterSelector = (state: RootState) =>
  messagesStateSelector(state).overview.filters.appliedFilter;

export const messagesSearchSelector = (state: RootState) => messagesStateSelector(state).overview.filters.search;
